module.exports = __webpack_public_path__ + "img/moving_forward_mobile.0ff11a5f.png";